const courseApi = {
  GETCOURSE: '/applyCourse/getAllCourse', //获取所有课程
  DELECTCOURSE: '/applyCourse/deleteCourse', //删除某个项目
  EXPORTCOURSE: '/applyCourse/exportCourses', //导出项目
  COURSETOP: '/applyCourse/topCourse', //置顶某个课程
  UPDATECOURSE: '/applyCourse/updateCourse', //更新课程
  COURSEDETAIL: '/applyCourse/getCourse', //获取某一个课程基本信息
  COURSEADD: '/applyCourse/apply' //添加课程
}
export default courseApi
